import { FaBalanceScale, FaBook, FaBookOpen, FaBriefcaseMedical, FaCalendarAlt, FaChartBar, FaChartLine, FaClock, FaCogs, FaComments, FaCrown, FaExclamationTriangle, FaEye, FaGlobe, FaGraduationCap, FaHandHolding, FaHandHoldingHeart, FaHandshake, FaHandsHelping, FaHeartbeat, FaIdCard, FaLightbulb, FaMapMarkedAlt, FaNetworkWired, FaPencilRuler, FaPuzzlePiece, FaRandom, FaSeedling, FaShieldAlt, FaStar, FaSyncAlt, FaTasks, FaTrophy, FaUserFriends, FaUserGraduate, FaUsers, FaUserTie } from "react-icons/fa";
import Breadcrumb from "../Breadcrumb";
import ClientsSection from "../../Home/clients-section";
import ServiceRegister from "./components/leadership-solutions/service-register";
import LSServices1 from "../../../assets/used-images/learning-solutions-services-1.png"
import LSServices2 from "../../../assets/used-images/learning-solutions-services-2.jpg"
import LSServices3 from "../../../assets/used-images/learning-solutions-services-3.jpg"
import LSServices4 from "../../../assets/used-images/learning-solutions-services-4.png"
import LSServices5 from "../../../assets/used-images/learning-solutions-services-5.png"
import LSServices6 from "../../../assets/used-images/learning-solutions-services-6.jpg"
import LSServices7 from "../../../assets/used-images/learning-solutions-services-7.jpg"
import LSServices8 from "../../../assets/used-images/learning-solutions-services-8.jpg"
import LSServices9 from "../../../assets/used-images/learning-solutions-services-9.jpg"
import LSServices10 from "../../../assets/used-images/learning-solutions-services-10.png"
import LSServices11 from "../../../assets/used-images/learning-solutions-services-11.png"
import LSServices12 from "../../../assets/used-images/learning-solutions-services-12.jpg"
import LSServices13 from "../../../assets/used-images/learning-solutions-services-13.jpg"
import LSServices14 from "../../../assets/used-images/learning-solutions-services-14.jpg"

import { useState } from "react";
import Certification from "../../../assets/used-images/hr-certification.png";
import IvoryGold from "../../../assets/used-icons/IvoryGold.svg";
import VideoOne from "../../../assets/used-icons/level-1.png";
import {
    TvMinimal,
    ClipboardList,
    Gauge,
    Users,
    BookOpen,
    Cloud,
} from "lucide-react";
// import Image from "../../ui/Image";
import { useTranslation } from 'react-i18next';
import ServiceApplyBtn from "../../ui/ServiceApplyBtn";
import DevelopmentStrategiesSection from "./DevelopmentStrategiesSection";
import Grades from "./grades";
import GradesFour from "./Grades-4";


export default function LevelFour() {
    const { t } = useTranslation();
    const [triggeredSection, setTriggeredSection] = useState(0);
    const [seeBox, setSeeBox] = useState(false);
    const percentages = [25, 15, 30, 30]; 
    const labels = [
      'مفاهيم ومعارف',
      'استبيانات قياس مهارات',
      'أوراق عمل وتخطيط شخصي',
      'أنشطة تطبيقية ومهام تعاونية',
    ]; 
    const services = [
        {
            title: 'المحاضرة',
            image: LSServices1
        },
        {
            title: 'الاستبيانات والاختبارات',
            image: LSServices2
        },
        {
            title: 'الممارسة التطبيقية',
            image: LSServices3
        },
        {
            title: 'المهام العملية والتعاونية',
            image: LSServices4
        },
        {
            title:'المشروعات الختامية',
            image: LSServices5
        },
       
    ];
    
    const dimensions = [
        {
            trigger: 'للمنظمة',
            items: [
                {
                    title:'تحقيق التناغم بين صاحب المنشأة وأدائها العام',
                    icon: <FaBookOpen size={20} />,
                    details: t(`leadership.item-one-details`, {returnObjects : true})
                },
                {
                    title:'توجيه ممارسات المنشأة نحو أهداف واضحة',
                    icon: <FaBalanceScale size={20} />,
                    details: ['صياغة المهمة الشخصية', 'القدوة والالتزام', 'الشجاعة الاخلاقية']
                },
                {
                    title: 'زيادة إنتاجية العاملين وترسيخ الالتزام والمسؤولية',
                    icon: <FaPencilRuler size={20} />,
                    details: ['نشأة اخلاقيات العمل', 'القيادة الاخلاقية', 'التصرف الاخلاقي']
                },
                {
                    title: 'رفع كفاءة التواصل بين الأفراد والحدات الإدارية',
                    icon: <FaStar size={20} />,
                    details: ['القيم الشخصية', 'القيم المؤسسية', 'الدور والغاية']
                },
                {
                    title: 'تخفيض معدل دوران العمالة وبناء الكوادر',
                    icon: <FaHandHoldingHeart size={20} />,
                    details: ['القيادة الرحيمة', 'البهجة والمرح', 'التنمر والتحرش']
                },
                {
                    title: 'إدارة المخاطر وتطوير بيئة عمل صحية ومتوازنة',
                    icon: <FaComments size={20} />,
                    details: ['الاستماع النشط', 'السرد القصصي', 'إظهار القوة']
                },
                {
                    title: 'تخطيط وإدارة العلاقات الخارجية بفعالية',
                    icon: <FaHandshake size={20} />,
                    details: ['أهمية الثقة', 'كسب الثقة', 'استعادة الثقة']
                },
                {
                    title:'تعظيم الاستفادة من التنوع الثقافي بين العاملين',
                    icon: <FaExclamationTriangle size={20} />,
                    details: ['دراسة الحالة', 'التعاطف', 'منطقة الراحة']
                }
            ]
        },
        {
            trigger: 'للفرد ',
            items: [
                {
                    title: 'تطوير مهارات القيادة والتأثير وترسيخ ثقافة الإنتاج',
                    icon: <FaChartLine size={20} />,
                    details: ['النماذج الاستراتيجية', 'التخطيط', 'التفكير الاستراتيجي']
                },
                {
                    title: 'فهم الدوافع الشخصية للعاملين وترسيخ روح العمل الجماعي',
                    icon: <FaShieldAlt size={20} />,
                    details: ['فهم المخاطر التنظيمية', 'إدارة المخاطر', 'قياس المخاطر']
                },
                {
                    title: 'رفع كفاءة الأداء من خلال آليات إدارة المشاعر وتوجيه السلوك',
                    icon: <FaSyncAlt size={20} />,
                    details: ['مفهوم التغيير', 'نماذج إدارة التغيير', 'الإدارة العاطفية للتغيير']
                },
                {
                    title: 'إثارة اهتمام العاملين بأهداف المنشأة وزيادة التفاعل والهام الحماس',
                    icon: <FaStar size={20} />,
                    details: ['الدافع والمشاركة', 'التشجيع', 'نمذجة الدور']
                },
                {
                    title: 'قيادة الجهود باستخدام استراتيجيات التوجيه والإرشاد',
                    icon: <FaLightbulb size={20} />,
                    details: ['مفهوم الإبداع', 'الذات المبدعة', 'إدارة الإبداع التنظيمي']
                },
                {
                    title: 'إدارة الغضب وفض النزاعات عبر منهجيات التفاوض والوساطة',
                    icon: <FaEye size={20} />,
                    details: ['القيادة الرقمية', 'رصد التوجهات', 'تخطيط السيناريوهات']
                },
                {
                    title: 'دمج التصورات المستقبلية في عمليات التشغيل الحالية',
                    icon: <FaLightbulb size={20} />,
                    details: ['مفهوم الابتكار', 'إدارة الابتكار', 'التطوير الدائم']
                },
                {
                    title: 'تعزيز حرص العاملين على التعلم والتطوير الدائمين',
                    icon: <FaLightbulb size={20} />,
                    details: ['مفهوم الابتكار', 'إدارة الابتكار', 'التطوير الدائم']
                },
               
            ]
        },
        {
            trigger: 'التسليمات',
            items: [{
                title: 'شهادة حضور البرنامج المشترك من العاج الفضي',
                icon: <FaHeartbeat size={20} />,
                details: ['الانضباط', 'إدارة الأزمات', 'عقلية النمو']
            },
            {
                title: 'شهادة ووثيقة اعتماد رقميتين من IL ',
                icon: <FaChartBar size={20} />,
                details: ['مراجعة الأداء', 'علاج ضعف الأداء', 'تحديد أهداف الأداء']
            },
            {
                title: ' عضوية مجانية في IL',
                icon: <FaBriefcaseMedical size={20} />,
                details: ['الصحة والسلامة', 'العافية والصحة النفسية', 'التوازن المهني الشخصي']
            },
           ]
        },
        {
            trigger: 'عضوية معهد IL',
            items: [
                {
                    title: ' التطوير',
                    icon: <FaLightbulb size={20} />,
                    details: ['المبادرة الواثقة', 'رصد الفرص', 'التوجهات']
                },
                {
                    title: ' الاطلاع',
                    icon: <FaChartLine size={20} />,
                    details: ['الكيانات القانونية التجارية', 'نموذج العمل التجاري', 'قيادة القطاع العام']
                },
                {
                    title: '  الاعتراف',
                    icon: <FaCogs size={20} />,
                    details: ['المرؤوس المهني', 'إدارة الرؤساء', 'الإبداع التشاركي']
                },
                {
                    title: ' التواصل',
                    icon: <FaUsers size={20} />,
                    details: ['التفويض', 'التمكين', 'التفاعل']
                },
                
            ]
        },
     
    ];
    const programLevels = [
        {
            title: "برنامج القيادة التنفيذية المتقدمة المعتمدة للمستوى الأول",
            subtitle: "القيادات التنفيذية"
        },
        {
            title: "برنامج القيادة التنفيذية المتقدمة المعتمدة للمستوى الثاني",
            subtitle: "مدراء الإدارات"
        },
        {
            title: "برنامج القيادة التنفيذية المتقدمة المعتمدة للمستوى الثالث",
            subtitle: "المشرفون وقادة الفرق"
        },
        {
            title: "برنامج القيادة التنفيذية المتقدمة المعتمدة للمستوى الرابع",
            subtitle: "رواد الأعمال والمستثمرون"
        }
    ];
    const instituteInfos = [
        {
            title: "الرؤية",
            description: "صياغة التصور المستقبلي وبناء استراتيجية تحقق النمو والاستدامة."
        },
        {
            title: " المبادرة ",
            description: "التقدم نحو الأهداف وتخطيط الممارسة وحساب المخاطر."
        },
        {
            title: "العمل الجماعي",
            description: "التفاعل والتواصل وتوزيع الأدوار وتقبل الاختلاف."
        },
        {
            title: "   التكيف ",
            description: "قراءة الواقع والاستجابة للمتغيرات وتعديل الأداء وفقا للنتائج."
        },
        {
            title: " توليد النتائج",
            description: "استناد القرار على المعلومات وتحليل الخيارات تبعا للنتائج."
        },
        {
            title: "حكمة الأعمال",
            description: "الإدارة الاستراتيجية للموارد والأموال والأفراد والمعلومات."
        },
        {
            title: " العلاقات ",
            description: "بناء وصيانة العلاقات الخارجية بما يخدم المصالح ويعزز القدرات."
        },
        {
            title: " الشخصية  ",
            description: "إظهار السمات السلوكية الداعمة للتطوير والتوجيه والمساءلة."
        }
    ];
    const coreSkills = [
        {
            title: "ورش عمل",
            number: "17"
        },
        {
            title: "شهور",
            number: "7"
        },
        {
            title: "يوم تدريب",
            number: "49"
        },
        {
            title: "ساعة تدريب",
            number: "98"
        },
       
    ];
    const mainSkillsArray = [
   'إكتساب الوعي بالأهداف الشخصية ونمط القيادة الطبيعي لدى المشارك.',
   'صياغة تصور لمستقبل المنشأة يتواءم والأهداف والميول الشخصية.',
   'تفعيل آليات المرونة ومقاومة الإجهاد لتحقيق النتائج واستدامة النمو.',
   'تأسيس علامة شخصية للمشارك ودمجها في ثقافة العاملين.',
   'توجيه أداء العاملين أفرادا ومجموعات لتحقيق مصلحة مشتركة.',
   'ترسيخ انتماء العاملين وبناء الثقة والولاء تجاه المنشأة.',

     ,
  ];
    const trainingFeatures = [
        {
            title: "المهام والمشروعات",
            icon: <ClipboardList size={25} />,
            description: "صفحات المهام وردود أعضاء الفرق والتواصل مع المدرب برسائل نصية"
        },
        {
            title: "التقييم والقياس",
            icon: <Gauge size={25} />,
            description: "اختبارات قياسية شخصية ومهارية و استبيانات رأي و استقصاءات"
        },
        {
            title: "المشاركة والتفاعل",
            icon: <Users size={25} />,
            description: "تفاعل المشاريع مع المدرب بالصوت والصورة واجتماعات الفيديو بين أعضاء الفرق"
        },
        {
            title: "الموارد التعليمية",
            icon: <BookOpen size={25} />,
            description: "رفع وتنزيل الملفات ومقاطع الفيديو"
        },
        {
            title: "النسخة السحابية",
            icon: <Cloud size={25} />,
            description: "المحتوى التدريبي والمواد التعليمية وتسجيلات صوتية ومرئية للجلسات التدريبية قابلة للتشغيل والتنزيل"
        }
    ];
    return (
        <>
            <Breadcrumb pages={["المنتجات", "حلول التطوير القيادي","المستوى الرابع"]} />
            <main className="">
                <section className="relative border rounded-lg text-right container mt-5 mb-5">
                    <div className="flex justify-center items-center">
                        <div className="absolute -top-4 bg-primary-tw text-white px-4 !py-3 rounded-xl">
                        برنامج القيادة التنفيذية المتقدمة المعتمدة
للمستوى الرابع
                                            </div>
                    </div>
                    <article className="!px-2 text-center mt-5">
                    تعقد ورش العمل عن بعد في 3 أيام، بواقع ساعتين لليوم الواحد نتهي كل مرحلة بمهمة أو مشروع فردي، يعمل عليه المشارك خلال فترة التوقف تهدف ورشة عمل إدارة العضوية إلى تمكين المشارك من إدارة حسابه التطويري على موقع معهد القيادة IL والتعرف على كافة الخدمات والموارد التطويرية في موقع المعهد الإلكتروني تستغرق ورشة عمل إدارة العضوية ساعتان.




</article>

                </section>
                 {/* الجدارات المعتمدة */}
            <section className="bg-primary-tw py-8 grid place-items-center p-3 ">
                

                <div className="row justify-content-between align-items-center w-100">
                    {
                        coreSkills.map((skill, i) => (
                            <div key={i} className=" text-center col-lg-3 col-md-5 w-full text-white">
                                <div className="size-12 flex justify-center items-center w-100 rounded-full  text-secondary-tw ">
                                    <span className="text-lg font-bold">
                                       {skill.number}
                                    </span>
                                </div>
                                <p className="text-xl ">
                                    {skill.title}
                                </p>
                               
                            </div>
                        ))
                    }
                </div>
            </section>
            <div className="container">
                <section className=" grid grid-cols-[65%_29%] max-md:grid-cols-1 gap-4 mt-5 mb-5">
                  
                    <div className="border rounded-lg p-3">
                        <h2 className="services-header after:w-20 after:-bottom-2">
                        النظرة العامة                        </h2>
                        <article className="text-semi-gray text-justify mt-4">
                        تعد المنشآت التجارية الصغيرة والمتوسطة حيوية للاقتصاد المحلي. وبينما تلعب العوامل الخارجية دورا في نجاحها أو عدمه، فإن كفاءة قيادتها غالبا ما تحدد نجاحها واستمراريتها. ذلك أن أثر القيادة في المنظمات الصغيرة التي تأسست على العاطفة والرؤية، ويقودها رواد أعمال منفردين أو فرق صغيرة تعمل بموارد وميزانية محدودة، يكون أكبر بكثير منه في المنظمات الكبيرة ذات الهياكل الراسخة وفرق العمل الخبيرة. يلزم لأصحاب ومشغلي المنشآت الصغيرة والمتوسطة تطوير رؤاهم وقدراتهم القيادية لتحسين عائد الاستثمار. حيث لا تكفي الإدارة الكفوءة وحدها لتحقيق ذلك مع فريق صغير يضطلع بأعمال كثيرة وبدون خبرة كافية. إن حرية اتخاذ القرار وإدارة الوقت وتحديد الأولويات التي تتاح لمالك مشروع صغير أو متوسط، تستلزم في الأساس إدراكا وافيا لما يريد تحقيقه، ومعرفة بوسائل وآليات التنفيذ. كذلك يتطلب إلهام الفريق وتوجيهه صوب أهداف مشتركة، وفي إطار استراتيجي واضح وتخطيط مدروس، مهارات خاصة لدى صاحب المشروع، تعينه على ربط ممارساته الإدارية بأخرى قيادية تدعم تفاعل الفريق ومشاركته بحماس وتناغم.





                        </article>
                    </div>
                    <div className="w-full  rounded-xl relative">
                        <img
                            src='https://ivorytraining.com/li/assets/img/last/last.png'
                            alt={'learing solutions'}
                            className={'w-full h-full object-cover object-top rounded-xl'}
                        />
                    </div>
                </section>
                </div>
                  {/* مهارات اساسيه */}
            <section className="bg-[#F5F5F5] py-5  ">
                <div className="container">
                <div className=" p-4 flex flex-col items-center !gap-4">
                    
                  
                    <h2 className="services-header after:w-20 after:-bottom-2">
                    طبيعة البرنامج واهدافه                   
                        </h2>

                   
                    <p className=" text-slate-400 lg:px-20">
                    صمم هذا البرنامج لإكساب أصحاب المنشآت الصغيرة والمتوسطة المعارف والمهارات التي تمكنهم من قيادة فريق العمل برؤية واضحة للمستقبل، وبفعالية في إثارة الشغف للتعلم، وتوجيه الجهود نحو الأداء المستهدف، تبعا لطبيعة كل عضو في الفريق.



</p>
                </div>
                <div className="grid place-items-center xl:grid-cols-3 lg:grid-cols-2 gap-8 px-4 my-6">
                    {
                        mainSkillsArray.map((skill, i) => (
                            <div key={i} className="border px-4 py-8 rounded-lg text-right relative z-0 w-full bg-white text-secondary-tw">
                                <div className="size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white" style={{right:'45%'}}>
                                    <span className="text-lg font-bold -secondary-tw">
                                        {++i}
                                    </span>
                                </div>
                                <p className="fs-6  text-center mt-2" style={{color:'#7A7A7A'}}>
                                    {skill}
                                </p>
                            </div>
                        ))
                    }
                </div>
                </div>
               
               
            </section>
                {/*  الابعاد القيادية و جدارتها */}
                <section className="container">

                    <div className="grid place-items-center my-4">
                        <p className="services-header flex justify-center after:w-32 after:-bottom-2">
أهمــية المشــاركة للفــرد والمنظــمة
                        </p>
                    </div>
                    <section>
                        <div className="flex justify-content-center items-center gap-2 scrolling">
                            {
                                dimensions.map((item, i) => (
                                    <button key={i}
                                        className={`px-4 py-1 rounded-md border ${i === triggeredSection ? 'bg-primary-tw text-white' : 'text-slate-400'}`}
                                        onClick={() => setTriggeredSection(i)}>
                                        {item.trigger}
                                    </button>
                                ))
                            }
                        </div>

                        <div className="grid lg:grid-cols-4 gap-4 my-4">
                            {
                                dimensions[triggeredSection].items?.map((item, i) => (
                                    <p className="border p-2 rounded-md hover:bg-secondary-tw/5 transition-all mt-4" key={i}>
                                        <summary className="flex items-center flex-column gap-2 cursor-pointer p-2">
                                            <p className="flex justify-center items-center rounded-full bg-secondary-tw text-white" style={{ width: '40px', height: '40px',marginTop:'-25px' }}> {item.icon} </p>
                                           {item.title}
                                        </summary>
          

                                    </p>
                                ))
                            }
                        </div>
                    </section>
                </section>
              
                {/* program levels */}
                {/* <section className="grid lg:grid-cols-2 xl:grid-cols-4 gap-10 mt-12">
                    {
                        programLevels.map((program, i) => (
                            <div key={i} className="border-2 rounded-lg !p-4 relative grid gap-4 bg-[#e9e9e9]">
                                <div className="flex justify-center items-center">
                                    <div className=" absolute -top-6 bg-secondary-tw text-xl rounded-full size-12 flex justify-center items-center text-white">
                                        {i++}
                                    </div>
                                </div>
                                <p className="text-common-text">
                                    {program.title}
                                </p>
                                <p className="text-secondary-tw text-lg font-semibold">
                                    {program.subtitle}
                                </p>
                            </div>
                        ))
                    }
                </section> */}

               <div className="container">
               <div className="grid place-items-center my-4">
                        <p className="services-header flex justify-center after:w-32 after:-bottom-2">
                        نمــوذج الجــدارات المســتهدفة
                        </p>
                        <p className=" text-slate-400 lg:px-20">
                        صمم هذا البرنامج ليجمع للمشارك صاحب المنشأة بين تطوير الرؤية وإحداث التغيير ورفع كفاءة الأداء. حيث يركز على تطوير منهجية التفكير وبناء ثقافة تدمج المسؤولية والملكية معا. ويعمل على ترسيخ جدارات القيادة التحويلية التي تكفل استجابة العاملين للمتغيرات بمرونة وفعالية. ويعزز لدى المشارك مفاهيم التكيف والتعلم المستمر والعمل الجماعي لتحقيق النمو.





                        </p>
                    </div>
<section className="grid grid-cols-[40%_59%] gap-2 " style={{margin:'80px 0'}}>
<img src={VideoOne} alt="video" className="w-full h-full object-cover rounded-lg" />
                <section className="grid lg:grid-cols-2 gap-8">
                    {
                        instituteInfos.map((info, i) => (
                            <div className="!border-2 !border-b-4 border-b-secondary-tw !p-3 rounded-lg">
                                <h2 className="flex items-center gap-2 text-secondary-tw text-lg font-semibold">
                                    <img src={IvoryGold} alt="ivory-icon" className="w-3" />
                                    <span>{info.title}</span>
                                </h2>
                                <article className="text-right text-common-text">
                                    {info.description}
                                </article>
                            </div>
                        ))
                    }
                </section>
                </section>
                </div>
            </main>
            <div className="container mt-5 mb-5">
                
    <GradesFour/>
    </div>

           <section className="container text-center">
           <div className="grid place-items-center my-4">
           <p className="services-header flex justify-center after:w-32 after:-bottom-2">
           منهجــية التنفــيذ
           </p>
           </div>
           <p className=" text-slate-400 lg:px-20">
           حيث يوفر منهج الممارسة العملية بيئة تعليمية فعالة في تطوير المهارات القيادية الداعمة للحلول الإبداعية، دون تجاوز الإطار الزمني للمهام. وعليه فإنه بحسب طبيعة البرنامج والفئة المستهدفة منه، يتم نقل المعرفة للمشاركين فيه عبر خمس استراتيجيات


            </p>
         

                <div className="grid grid-cols-3 gap-8 py-6 px-2 max-xl:grid-cols-2 max-lg:grid-cols-1">
                    {
                        services.map((service, i) => (
                            <div key={i} className="text-center relative flex justify-center">
                                <div className="w-full h-52">
                                    <img src={service.image} alt={service?.title} className="rounded-lg w-full h-full object-cover" />
                                </div>
                                <div className="bg-light-red absolute z-0 w-full h-full rounded-lg top-0"></div>
                                <p className="text-lg text-white absolute z-10 bottom-3 font-semibold m-0">
                                    {service.title}
                                </p>
                            </div>
                        ))
                    }
                </div>
          
                </section>
                <section className="container text-center">
                      <DevelopmentStrategiesSection percentages={percentages} labels={labels} />
                </section>
            
           
        </>
    )
}